import type { GTMEventReturnType } from './GTM.types';

export interface GTMBaseReturnType
    extends Omit<GTMEventReturnType, 'ga4_property' | 'ga4_event_name'> {}

export default abstract class GTMBaseModel {
    public static parseToGTMData: (data: any) => any;

    protected static getBaseData(): GTMBaseReturnType {
        return {
            event: 'gtm_event'
        };
    }
}
